// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3fiKn","col":"Table_col__2t7Fy","fulfillmentStatus":"Table_fulfillmentStatus__2sskj","emailCol":"Table_emailCol__3hHNA"};